import React, { Component } from 'react'
import Radium from 'radium'
import Cookies from 'js-cookie'

/* const iOSShareBase64 =
  'iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAActpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx4bXA6Q3JlYXRvclRvb2w+QWRvYmUgSW1hZ2VSZWFkeTwveG1wOkNyZWF0b3JUb29sPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KKS7NPQAAAsxJREFUSA2lVjFrFFEQnnm7l2iiF2LuEggWImchFjb5B4KFhZ3+AC1io1hZJedyYGNjERANaB9FG0FBBGuLIBamukYQRXN4GnKSy+6+cebt283buz3dmIF3O2/ezHwz82ZnD+BfdIm8VKW+vLsmK92Dc5bJ9sUEpFL9+nL4bPYOkSzhUzk4OpnMYdDh86wYBqjFQU1HrxGoDoA9qzRBAJ2O8s+nOuaZ92B2xQBECIh0JqCxbzp6yUpnp7r+8a1j8WMADdUfn678mj7xmUE+zCn/wscAd8HaDGJkJRg8kH0XvvqI8A6VPtdewT6LjrCfo+2VU32RyVkXwC+yHSHjyCUSWQW1rTej57KGjEU3tQO2dchBlwMk2DvmCpQkc1eurvXFogTgCbfiZYxrSzsXUal7DBQDmPaMEPiOgR51WpVbLMsCqjXDuwrwKoHuAChuZdJiQ6Budlr4AqzPxOANyF3EgF6DL/ckkb7GNpMQx2I0gYjvJT5OjvcJcRe8JaKfnOZv8FCB1j1E7wEQNIyG9ZkAzLNYCBUh6Y3N1thDsx/4YaUMYLPlv+JjWRnNNsMbnEGytz6zlFMtjuqw4blF4UsC3BgHJV1Ezg01rtN4u28B5zk5blVju3eHxk0egDRnbrO5DaG8C6LVDpLac6mSTEU2wyUNMDJeTNcxJ7biw6E8gHNQxHKEOeMiHSmzK98XACobsethkD9gBtOD/ob2/5mB6R6llPsWZx01BOIIypXITtXvAd43tumkdRyNYssBiLWApB+YQN70clQeQPw9Le84hf/ruE6VDvLMZ2A6wLbx4rrPA6vURcLiugQa8tAbiiUPwOORh1ZS39WFEFaH9EcJEhsSW/4MOZQDQB2LQnVmiU77GFYjz44Nx6CI9XkOR1TZ4t8qT4sEzCrmAFi2rSb9OdyBDVIVyP6vFHl1ZPLl8LiYeMgH3Qu3nSP4A9EHFXrGnVaNAAAAAElFTkSuQmCC'
const closeBase64 =
  'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAl0lEQVR4Ae2TMQ6DMBTFfA+kHqkSUmcKgd5/BIaEqsOfWqyILgx4jewl/3FxSm74q8ODlcQeL1Za769sFNKOXthYaBAS5Wci9ExH4AlG143xKxH6k0oiMbluTEQi9B5BEpW6fNtHH+CfQCEd13PcxVF9IHnC9V6us1qvTsjVScJ1SeicM53MbKZBaFlkcYmZO473aTghF2/X9XbQ39L36gAAAABJRU5ErkJggg==' */

class AddToHomeScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: navigator.standalone === false
    }
  }

  handleClose = () => {
    Cookies.set('addtohomescreen', true, { path: '/', expires: 1 })
    this.setState({
      visible: false
    })
  }

  render() {
    return (
      <div
        style={{
          position: 'fixed',
          // bottom: 20,
          left: '50%',
          transform: 'translateX(-50%)',
          display: this.state.visible ? 'inline-flex' : 'none',
          // display: 'inline-flex',
          color: '#124b5f',
          zIndex: 9999999999,
          height: '100%',
          width: '100%',
          background: 'rgba(0, 0, 0, 0.3)',
          flexDirection: 'column',
          justifyContent: 'flex-end'
        }}>
        <div>
          <div
            style={{
              padding: '14px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              background: 'rgb(6, 132, 137)',
              borderRadius: '5px 5px 0 0',
              width: 350,
              margin: '0 auto'
            }}>
            <p style={{ fontSize: 20, fontWeight: 600, color: '#fff' }}>Add to Home Screen</p>
            <div style={{ fontSize: 24, color: '#fff' }} onClick={() => this.handleClose()}>
              &times;
            </div>
          </div>
          <div
            style={{
              padding: 16,
              background: '#f5f5f5',
              width: 350,
              margin: '0 auto',
              borderRadius: '0 0 5px 5px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
            <p style={{ fontSize: 20, textAlign: 'center', color: '#124b5f' }}>
              Install GreenChoice app on your iPhone for the best experience.
            </p>
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
              <p
                style={{
                  fontSize: 20,
                  textAlign: 'left',
                  color: '#124b5f'
                }}>
                It’s easy, just tap
              </p>
              <div
                style={{
                  width: 40,
                  height: 40,
                  background: '#068489',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 0 0 6px'
                }}>
                <img src={require('../static/svgs/tap_ios.svg')} alt="tap_ios" style={{ width: 20 }} />
              </div>
              {/* <p
                style={{
                  fontSize: 20,
                  textAlign: 'left',
                  color: '#124b5f',
                  display: 'inline-flex',
                  alignItems: 'center'
                }}>
                and then “Add to Home Screen”.
              </p> */}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
              <p
                style={{
                  fontSize: 20,
                  textAlign: 'left',
                  color: '#124b5f'
                }}>
                and “Add to Home Screen”.
              </p>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {/* <p style={{ fontSize: 24, padding: '0 4px' }}>&rarr;</p> */}
                <img src={require('../static/images/addtohomescreen.png')} alt="tap_ios" style={{ width: 40 }} />
              </div>
              {/* <p
                style={{
                  fontSize: 20,
                  textAlign: 'left',
                  color: '#124b5f',
                  display: 'inline-flex',
                  alignItems: 'center'
                }}>
                and then “Add to Home Screen”.
              </p> */}
            </div>
          </div>
          {/* <div
          style={{
            width: 0,
            height: 0,
            borderLeft: '20px solid transparent',
            borderRight: '20px solid transparent',
            borderTop: '20px solid #124b5f',
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)'
          }}
        /> */}
          {/*  <div
          style={{
            width: 0,
            height: 0,
            borderLeft: '20px solid transparent',
            borderRight: '20px solid transparent',
            borderTop: '20px solid #fff',
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            bottom: '-19px'
          }}
        /> */}
          <div
            style={{
              width: 350,
              margin: '0 auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '14px 0 0 0'
            }}>
            <img
              style={{
                height: 240
              }}
              src={require('../static/svgs/ios_direction.svg')}
              onClick={this.handleClose}
              alt="addtohome"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default Radium(AddToHomeScreen)



// WEBPACK FOOTER //
// ./src/components/AddToHomeScreen.js